var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSubTranslHomepageIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.38753 11.1919C4.56821 9.40944 5.79277 8.05252 7.56249 7.77317C9.923 7.40056 14.0718 7 21 7C27.9282 7 32.077 7.40056 34.4375 7.77317C36.2072 8.05251 37.4318 9.40944 37.6125 11.1919C37.8089 13.1303 38 16.2391 38 21C38 25.7609 37.8089 28.8697 37.6125 30.8081C37.4318 32.5906 36.2072 33.9475 34.4375 34.2268C32.077 34.5994 27.9282 35 21 35C14.0718 35 9.92301 34.5994 7.56249 34.2268C5.79278 33.9475 4.56821 32.5906 4.38753 30.8081C4.19105 28.8697 4 25.7609 4 21C4 16.2391 4.19105 13.1303 4.38753 11.1919Z",
    fill: "#6491CF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.43093 15.2898C8.61668 13.5103 9.83361 12.1476 11.5989 11.8565C14.0665 11.4496 18.4918 11 26 11C33.5082 11 37.9335 11.4496 40.4011 11.8565C42.1664 12.1476 43.3833 13.5103 43.5691 15.2898C43.7841 17.3502 44 20.7307 44 26C44 31.2693 43.7841 34.6498 43.5691 36.7102C43.3833 38.4897 42.1664 39.8524 40.4011 40.1435C37.9335 40.5504 33.5082 41 26 41C18.4918 41 14.0665 40.5504 11.5989 40.1435C9.83361 39.8524 8.61668 38.4897 8.43093 36.7102C8.21586 34.6498 8 31.2693 8 26C8 20.7307 8.21586 17.3502 8.43093 15.2898Z",
    fill: "#DCE2F5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3165 21.7403C20.5756 20.0717 22.0676 19.1256 23.6689 19.6616C24.8215 20.0474 26.3907 20.6582 28.4706 21.625C30.0757 22.3711 31.3767 23.0466 32.4167 23.6312C34.4424 24.77 34.4424 27.23 32.4167 28.3688C31.3767 28.9534 30.0757 29.6289 28.4706 30.375C26.3907 31.3418 24.8215 31.9526 23.6689 32.3384C22.0676 32.8744 20.5756 31.9283 20.3165 30.2597C20.1424 29.1389 20 27.7019 20 26C20 24.2981 20.1424 22.8611 20.3165 21.7403Z",
    fill: "#6491CF"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubTranslHomepageIcon);
export default __webpack_public_path__ + "static/media/subTranslHomepageIcon.dafc0fedd30282e1e08f1117d7b3748d.svg";
export { ForwardRef as ReactComponent };